import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import TextArea from "../../../TextArea/TextArea"
import ProfileTableItem from "../../ProfileTableItem"
import Button from "../../../Button/Button"
import styles from "./MyInspiration.module.scss"
import classNames from "classnames"
import validation from "./validation"
import { Prompt } from "react-router-dom"
import ConfirmCancelPopup from "../../../Popup/ConfirmCancelPopup"
import { messages } from "../../../../helpers/constants"

const MyInspiration = ({ data, update, anotherUser }) => {
  const maxLength = 1000
  const placeholder = "Tell us more about what inspires and drives you!"
  const [editedState, setEditedState] = useState("")
  const [isPopupOpened, setIsPopupOpened] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [hasChanges, setHasChanges] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  const textArea = React.useRef(null)

  useEffect(() => {
    if (data) {
      setEditedState(data)
    }
    if (data === null) {
      setEditedState("")
    }
  }, [data])

  useEffect(() => {}, [])

  const onChangeText = (e) => {
    setEditedState(e.target.value)
    setHasChanges(true)
    setErrorMessage(validation(e.target.value))
  }

  const handleSave = () => {
    setHasChanges(false)
    setIsEditing(false)
    update({ my_inspiration: editedState.trim() })
  }

  const handleClosePopup = () => {
    setEditedState(data)
    setIsEditing(false)
    setErrorMessage("")
    setIsPopupOpened(false)
    setHasChanges(false)
  }

  const handleCancel = () => {
    if (hasChanges) {
      setIsPopupOpened(true)
    } else {
      setErrorMessage("")
      setEditedState(data)
      setIsEditing(false)
    }
  }

  return (
    <div className={styles.wrap}>
      <Prompt
        when={hasChanges}
        message={messages.CONFIRM_DISCARD_FORM_CHANGES_ON_PAGE_LEAVE}
      />
      <ProfileTableItem
        title="My Inspiration"
        description="Tell us more about what inspires and drives you!"
        linkText="+ Add your inspiration"
        onClick={() => {
          setIsEditing(true)
          setTimeout(() => {
            textArea.current.selectionStart = editedState?.length + 1
            textArea.current.focus()
          })
        }}
        hasData={!!(data && data.length)}
        isActive={isEditing}
        anotherUser={anotherUser}
      />
      {isPopupOpened && hasChanges && (
        <ConfirmCancelPopup
          handleCancel={handleClosePopup}
          setIsPopupOpened={setIsPopupOpened}
        />
      )}
      {/* {data && ( */}
      <div
        className={classNames({
          [styles.wrapper]: data || isEditing,
          [styles.hiddenWrapper]: !data && !isEditing,
        })}
      >
        <div className={styles.content}>
          {isEditing ? (
            <TextArea
              vertical
              error={Boolean(errorMessage && errorMessage.length > 0)}
              errorMessage={errorMessage}
              value={editedState}
              placeholder={placeholder}
              onChange={onChangeText}
              currentLength={editedState?.trim().length}
              maxLength={maxLength}
              style={styles.textArea}
              ref={textArea}
            />
          ) : (
            <div className={styles.contentText}>{data}</div>
          )}
        </div>
      </div>
      {/* )} */}
      {isEditing && (
        <div className={styles.btnsWrap}>
          <Button
            className={classNames(styles.cancelButton, styles.btn)}
            buttonStyle="outlined"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            buttonStyle="contained"
            className={styles.btn}
            disabled={Boolean(errorMessage && errorMessage.length > 0)}
          >
            Save
          </Button>
        </div>
      )}
    </div>
  )
}

MyInspiration.propTypes = {
  data: PropTypes.string,
}

MyInspiration.defaultProps = {
  data: "",
}

export default MyInspiration
